import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import CustomLoader from '../../../components/CustomLoader';
// import LogoImg from '../../../images/Logo/logo-big.png';
import './mailForm.scss';

// ─── SIGNATURE ────────────────────────────────────────────────────────────────

const SIGNATURE = () => `
<br/><br/>
<hr style="border:none;border-top:1px solid #e2e8f0;margin:24px 0 16px;"/>
<table cellpadding="0" cellspacing="0" border="0" style="font-family:Arial,sans-serif;font-size:13px;color:#1e293b;">
  <tr>
    <td style="padding-right:20px;vertical-align:top;border-right:3px solid #e54d01;padding-right:16px;">
      <p style="margin:0 0 2px;">Thanks &amp; Regards,</p>
      <p style="margin:0 0 6px;font-size:16px;font-weight:bold;color:#0c3969;">DIPEN VORA</p>
      <p style="margin:0 0 12px;font-size:12px;color:#64748b;letter-spacing:1px;">PROPRIETOR</p>
    </td>
    <td style="padding-left:20px;vertical-align:top;">
      <p style="margin:0 0 4px;font-size:12px;font-weight:bold;color:#0c3969;">DEEP PRABHA TRANSCHEM</p>
      <p style="margin:0 0 8px;font-size:11px;color:#64748b;line-height:1.6;">
        <strong>Registered Office:</strong><br/>
        Office No: 1008, 10th Floor, Manisha Corporate Park,<br/>
        M.G. Road, Mulund West, Mumbai - 400080.
      </p>
      <p style="margin:0;font-size:11px;color:#64748b;line-height:1.9;">
        📞 <a href="tel:+919619688861" style="color:#0c3969;text-decoration:none;">+91 9619688861</a> / <a href="tel:+919323688861" style="color:#0c3969;text-decoration:none;">9323688861</a><br/>
        ✉️ <a href="mailto:info@deepprabha.com" style="color:#0c3969;text-decoration:none;">info@deepprabha.com</a><br/>
        🌐 <a href="https://www.deepprabha.com" style="color:#0c3969;text-decoration:none;">www.deepprabha.com</a>
      </p>
    </td>
  </tr>
</table>`;

// ─── EMAIL TEMPLATES ──────────────────────────────────────────────────────────
const TEMPLATES = [
    {
        category: '🎉 Festivals & Occasions',
        items: [
            {
                label: 'Diwali Wishes',
                subject: '✨ Warm Diwali Wishes from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>As the festival of lights brightens our homes and hearts, we at <strong>Deep Prabha Transchem</strong> wish you and your family a very Happy Diwali! 🪔</p>
<p>May this Diwali illuminate your life with joy, prosperity, and success. We are grateful for your continued trust and partnership, and look forward to growing together in the years to come.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'New Year Wishes',
                subject: '🎊 Happy New Year from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>As we step into the New Year, we extend our warmest wishes to you and your team. 🎊</p>
<p>May the year ahead bring growth, prosperity, and exciting new opportunities. We are thankful for your continued association with <strong>Deep Prabha Transchem</strong> and look forward to serving you even better in the coming year.</p>
<p>Here's to a successful year ahead!</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Holi Wishes',
                subject: '🌈 Colourful Holi Wishes from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>Wishing you and your loved ones a joyful and vibrant Holi! 🌈</p>
<p>May the colours of Holi fill your life with happiness, health, and prosperity. Thank you for being a valued part of the <strong>Deep Prabha Transchem</strong> family.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Eid Mubarak',
                subject: '🌙 Eid Mubarak from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>On the joyous occasion of Eid, we wish you and your family <strong>Eid Mubarak!</strong> 🌙</p>
<p>May this blessed festival bring you peace, joy, and success. We are grateful for your trust in <strong>Deep Prabha Transchem</strong> and look forward to a prosperous partnership ahead.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Christmas Wishes',
                subject: '🎄 Season\'s Greetings from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>Season's Greetings and a very Merry Christmas to you and your family! 🎄</p>
<p>May this festive season bring you warmth, joy, and wonderful moments. We truly value our partnership and wish you a wonderful holiday season and a Happy New Year ahead.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Independence Day (15 Aug)',
                subject: '🇮🇳 Happy Independence Day from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>On this proud occasion of India's Independence Day, we extend our heartfelt wishes to you. 🇮🇳</p>
<p>Let us celebrate the spirit of freedom, growth, and unity. At <strong>Deep Prabha Transchem</strong>, we are proud to be part of India's thriving chemical industry and grateful for your continued support.</p>
<p>Jai Hind!<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Republic Day (26 Jan)',
                subject: '🇮🇳 Happy Republic Day from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>Wishing you a Happy Republic Day! 🇮🇳</p>
<p>On this day we celebrate the strength of our nation's constitution and the values of equality and progress. At <strong>Deep Prabha Transchem</strong>, we are committed to contributing to India's industrial growth alongside valued partners like you.</p>
<p>Jai Hind!<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Navratri / Durga Puja',
                subject: '🙏 Navratri Greetings from Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>Wishing you a blessed and joyful Navratri! 🙏</p>
<p>May Maa Durga bless you with strength, happiness, and success. We are grateful for your continued trust in <strong>Deep Prabha Transchem</strong> and look forward to a flourishing partnership.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
        ]
    },
    {
        category: '🤝 Business & Partnership',
        items: [
            {
                label: 'New Product Introduction',
                subject: '🧪 Introducing Our Latest Product Range — Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>We are excited to share that <strong>Deep Prabha Transchem</strong> has expanded its product portfolio with new specialty chemical compounds now available for supply.</p>
<p>Our new additions include high-purity solvents and reagents tailored for industrial and pharmaceutical applications, delivered with our commitment to quality and timely service.</p>
<p>We would love to discuss how these products can benefit your operations. Please feel free to reach out to us at <a href="mailto:info@deepprabha.com">info@deepprabha.com</a> or visit our website for more details.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Thank You — Valued Customer',
                subject: '🙏 Thank You for Your Continued Partnership',
                body: `<p>Dear Valued Partner,</p>
<p>We wanted to take a moment to sincerely thank you for your continued trust and partnership with <strong>Deep Prabha Transchem</strong>.</p>
<p>Your confidence in our products and services motivates us to consistently deliver the highest standards in chemical supply and customer care. We are committed to being your reliable partner for all your chemical requirements.</p>
<p>Looking forward to many more years of a fruitful relationship!</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Price Update Notice',
                subject: '📢 Important Update — Revised Pricing Effective Soon',
                body: `<p>Dear Valued Partner,</p>
<p>We hope this message finds you well. We would like to inform you of upcoming revisions to our product pricing, effective from [DATE].</p>
<p>This adjustment reflects changes in raw material and logistics costs. We remain committed to providing you with the best quality chemicals at competitive rates.</p>
<p>For a detailed revised price list or to place orders ahead of the update, please contact us at <a href="mailto:info@deepprabha.com">info@deepprabha.com</a>.</p>
<p>We appreciate your understanding and continued support.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
            {
                label: 'Re-engagement',
                subject: '👋 We Miss Working With You — Deep Prabha Transchem',
                body: `<p>Dear Valued Partner,</p>
<p>It has been a while since we last connected, and we wanted to reach out to check in and let you know we value your association with <strong>Deep Prabha Transchem</strong>.</p>
<p>We have exciting new products, improved delivery timelines, and competitive pricing available. We would love the opportunity to serve you again.</p>
<p>Feel free to reach out at any time — we are always here to help with your chemical supply requirements.</p>
<p>Warm regards,<br/><strong>Team Deep Prabha Transchem</strong><br/>Mumbai, India</p>`
            },
        ]
    }
];

const MailForm = () => {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState(SIGNATURE());
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [loading, setLoading] = useState(false);
    const [showTemplates, setShowTemplates] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/mail/groups`).then((res) => setGroups(res.data));
    }, []);

    const applyTemplate = (tpl) => {
        setSubject(tpl.subject);
        setBody(tpl.body + SIGNATURE());
        setShowTemplates(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!selectedGroup || !subject || !body) {
            setSnackbar({ open: true, message: 'Please fill all fields', severity: 'error' });
            setLoading(false);
            return;
        }
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/mail/send`, { groupId: selectedGroup, subject, body });
            setSnackbar({ open: true, message: 'Emails sent successfully!', severity: 'success' });
            setSubject('');
            setBody(SIGNATURE());
            setSelectedGroup('');
        } catch (err) {
            setSnackbar({ open: true, message: 'Failed to send emails', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mf">
            <CustomLoader show={loading} />

            {/* Header */}
            <div className="mf__header">
                <div>
                    <h2 className="mf__title">Send Group Email</h2>
                    <p className="mf__sub">Compose and send emails to a group of recipients.</p>
                </div>
                <button className="mf__tpl-btn" type="button" onClick={() => setShowTemplates(v => !v)}>
                    {showTemplates ? '✕ Close Templates' : '📋 Use a Template'}
                </button>
            </div>

            {/* Templates panel */}
            {showTemplates && (
                <div className="mf__tpl-panel">
                    <p className="mf__tpl-hint">Click any template to load it into the editor — you can edit before sending.</p>
                    {TEMPLATES.map(cat => (
                        <div className="mf__tpl-cat" key={cat.category}>
                            <div className="mf__tpl-cat-title">{cat.category}</div>
                            <div className="mf__tpl-grid">
                                {cat.items.map(tpl => (
                                    <button
                                        key={tpl.label}
                                        className="mf__tpl-card"
                                        type="button"
                                        onClick={() => applyTemplate(tpl)}
                                    >
                                        <span className="mf__tpl-card-label">{tpl.label}</span>
                                        <span className="mf__tpl-card-sub">{tpl.subject}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Form */}
            <form className="mf__form" onSubmit={handleSubmit} noValidate>
                <div className="mf__field">
                    <label className="mf__label">Recipient Group</label>
                    <select
                        className="mf__select"
                        value={selectedGroup}
                        onChange={(e) => setSelectedGroup(e.target.value)}
                    >
                        <option value="">— Select a group —</option>
                        {groups.map((g) => (
                            <option key={g._id} value={g._id}>{g.name}</option>
                        ))}
                    </select>
                </div>

                <div className="mf__field">
                    <label className="mf__label">Subject</label>
                    <input
                        className="mf__input"
                        type="text"
                        placeholder="Email subject..."
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </div>

                <div className="mf__field">
                    <label className="mf__label">Email Body</label>
                    <div className="mf__editor">
                        <ReactQuill theme="snow" value={body} onChange={setBody} />
                    </div>
                </div>

                <div className="mf__actions">
                    <button className="mf__send-btn" type="submit">
                        📨 Send to Group
                    </button>
                </div>
            </form>

            {/* Toast */}
            {snackbar.open && (
                <div className={`mf__toast mf__toast--${snackbar.severity}`}>
                    <span>{snackbar.message}</span>
                    <button onClick={() => setSnackbar(s => ({ ...s, open: false }))}>✕</button>
                </div>
            )}
        </div>
    );
};

export default MailForm;
